import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { SITE } from "@/lib/site";

export default function Footer() {
  return (
    <footer className="bg-navy-dark text-white" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 pb-10 pt-16 md:pt-20">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <div className="inline-block rounded-2xl bg-white p-3">
              <img
                src="/assets/logo.png"
                alt="Airconditioning Victoria logo"
                className="h-12 w-auto"
                width="230"
                height="50"
                loading="lazy"
              />
            </div>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-[#A9C6DC]">
              Heating and cooling solutions for Victorian homes since 2000.
            </p>
            <div className="mt-6 space-y-3 text-sm">
              <a
                data-testid="footer-phone-link"
                href={SITE.phoneHref}
                className="flex items-center gap-3 text-[#D6E7F2] transition-colors duration-200 hover:text-brand-cyan"
              >
                <Phone className="h-4 w-4 text-brand-cyan" /> {SITE.phone}
              </a>
              <a
                data-testid="footer-email-link"
                href={SITE.emailHref}
                className="flex items-center gap-3 break-all text-[#D6E7F2] transition-colors duration-200 hover:text-brand-cyan"
              >
                <Mail className="h-4 w-4 shrink-0 text-brand-cyan" /> {SITE.email}
              </a>
              <p className="flex items-start gap-3 text-[#D6E7F2]">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand-cyan" />
                <span>
                  {SITE.address1}
                  <br />
                  {SITE.address2}
                </span>
              </p>
            </div>
          </div>

          <nav aria-label="Air conditioning services">
            <h3 className="font-display text-xs font-bold uppercase tracking-[0.25em] text-brand-cyan">
              Air Conditioning
            </h3>
            <ul className="mt-5 space-y-3 text-sm text-[#D6E7F2]">
              <li><Link data-testid="footer-link-ducted" to="/ducted-air-conditioning" className="transition-colors duration-200 hover:text-brand-cyan">Ducted Air Conditioning</Link></li>
              <li><Link data-testid="footer-link-split" to="/split-system-air-conditioning" className="transition-colors duration-200 hover:text-brand-cyan">Split System Air Conditioning</Link></li>
              <li><Link data-testid="footer-link-multi-head" to="/multi-head-split-systems" className="transition-colors duration-200 hover:text-brand-cyan">Multi-Head Systems</Link></li>
            </ul>
          </nav>

          <nav aria-label="Company">
            <h3 className="font-display text-xs font-bold uppercase tracking-[0.25em] text-brand-cyan">
              Company
            </h3>
            <ul className="mt-5 space-y-3 text-sm text-[#D6E7F2]">
              <li><Link data-testid="footer-link-about" to="/about" className="transition-colors duration-200 hover:text-brand-cyan">About</Link></li>
              <li><Link data-testid="footer-link-warranty" to="/warranty" className="transition-colors duration-200 hover:text-brand-cyan">Warranty</Link></li>
              <li><Link data-testid="footer-link-veu" to="/veu-rebates" className="transition-colors duration-200 hover:text-brand-cyan">VEU Rebates</Link></li>
              <li><Link data-testid="footer-link-contact" to="/contact" className="transition-colors duration-200 hover:text-brand-cyan">Contact</Link></li>
            </ul>
          </nav>

          <nav aria-label="Legal">
            <h3 className="font-display text-xs font-bold uppercase tracking-[0.25em] text-brand-cyan">
              Legal
            </h3>
            <ul className="mt-5 space-y-3 text-sm text-[#D6E7F2]">
              <li><Link data-testid="footer-link-privacy" to="/privacy-policy" className="transition-colors duration-200 hover:text-brand-cyan">Privacy Policy</Link></li>
              <li><Link data-testid="footer-link-terms" to="/terms" className="transition-colors duration-200 hover:text-brand-cyan">Terms &amp; Conditions</Link></li>
            </ul>
            <p className="mt-6 text-xs leading-relaxed text-[#7FA3BC]">
              {SITE.legalName}
              <br />
              ABN {SITE.abn}
            </p>
          </nav>
        </div>

        <div className="mt-14 rounded-2xl border border-white/10 bg-white/5 p-6">
          <p className="text-xs leading-relaxed text-[#A9C6DC]" data-testid="footer-veu-disclaimer">
            Victorian Energy Upgrades incentives are subject to eligibility, approved-product
            requirements, installation requirements and current program rules. Please see our{" "}
            <Link
              to="/veu-rebates"
              data-testid="footer-veu-disclaimer-link"
              className="font-semibold text-brand-cyan transition-colors duration-200 hover:text-white"
            >
              VEU Rebates
            </Link>{" "}
            page for further information.
          </p>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 text-xs text-[#7FA3BC] md:flex-row md:items-center">
          <p>© 2026 Airconditioning Victoria Pty. Ltd. All Rights Reserved.</p>
          <p>Air Conditioning Melbourne &amp; Victoria</p>
        </div>
      </div>
    </footer>
  );
}
